import { render, staticRenderFns } from "./SalesInvoiceViewPayments.vue?vue&type=template&id=5d2866b7"
import script from "./SalesInvoiceViewPayments.vue?vue&type=script&lang=js"
export * from "./SalesInvoiceViewPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports